import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from './ui/dialog';
import { ANALYSIS_TEMPLATES } from '../lib/categories';
import {
  FileText,
  HelpCircle,
  GitBranch,
  BarChart3,
  RefreshCw,
  Target,
  Zap,
} from 'lucide-react';

const ICON_MAP = {
  FileText,
  HelpCircle,
  GitBranch,
  BarChart3,
  RefreshCw,
  Target,
  Zap,
};

const TemplatePickerDialog = ({ open, onOpenChange, onPick }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[720px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Template Library</DialogTitle>
          <DialogDescription>
            Pick an analysis template to dig into this issue.
          </DialogDescription>
        </DialogHeader>
        <div className="grid sm:grid-cols-2 gap-3">
          {ANALYSIS_TEMPLATES.map((tpl) => {
            const Icon = ICON_MAP[tpl.icon] || FileText;
            return (
              <button
                key={tpl.key}
                type="button"
                onClick={() => onPick(tpl.key)}
                className="flex items-start gap-3 p-4 rounded-lg border border-slate-200 hover:border-[#0090D8] hover:bg-sky-50 text-left transition-colors group"
              >
                <div
                  className="w-11 h-11 rounded-lg flex items-center justify-center text-white flex-shrink-0 group-hover:scale-110 transition-transform"
                  style={{ background: tpl.color }}
                >
                  <Icon className="h-5 w-5" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-slate-900">{tpl.label}</div>
                  <div className="text-xs text-slate-500 mt-0.5 leading-relaxed">
                    {tpl.description}
                  </div>
                  <div className="text-[10px] text-slate-400 mt-1.5">
                    {tpl.fields.length} fields
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TemplatePickerDialog;
